var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2470_23284)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    rx: 110,
    fill: "#133F7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3617 157.382C32.0627 158.355 18.6627 165.085 14 168.329C15.2163 189.919 36.9889 231.822 114.348 226.713C191.708 221.605 207.601 185.662 205.878 168.329C200.405 162.551 175.47 162.855 166.955 160.119C160.144 157.929 148.305 145.421 143.237 139.441L83.6357 131.23C78.669 139.542 64.6607 156.409 48.3617 157.382Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.832 156.17V172.287L67.5159 173.807L56.2647 185.971L66.6036 213.947",
    stroke: "#868686",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.262 159.966V174.109L153.578 175.63L164.829 187.793L154.49 215.769",
    stroke: "#868686",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7734 138.228L84.247 130.93L134.725 132.754L143.24 138.228C143.037 146.641 142.084 166.447 139.895 178.367C137.705 190.287 132.901 210.904 130.772 219.723C115.203 223.372 96.7145 221.243 89.4164 219.723C84.7943 211.452 80.3952 161.946 78.7734 138.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 159.516H105.534L101.277 165.597L107.359 175.328L95.1953 220.333C104.44 222.766 119.319 221.346 125.604 220.333L114.657 175.328L121.043 165.597L116.177 159.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9102 81.0612C66.9102 77.1689 69.3428 74.3713 70.5592 73.4591L78.4654 46.0913L136.242 52.173L146.277 74.3713C147.29 74.1686 149.743 74.6754 151.446 78.3244C153.575 82.8857 151.446 91.7042 150.534 94.1369C149.622 96.5696 146.581 105.084 143.844 105.388C141.655 105.631 140.702 104.273 140.499 103.564C138.674 109.341 130.464 132.452 107.962 132.452C89.9599 132.452 80.7968 110.76 78.4654 99.9145C78.3641 100.725 78.0397 102.59 77.5532 103.564C76.945 104.78 74.5123 105.692 72.0796 101.739C69.6469 97.7859 66.9102 85.9266 66.9102 81.0612Z",
    fill: "#FCCFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9414 130.928V114.508L135.94 111.163V134.273C133.264 141.328 121.851 152.822 116.479 157.688H105.227C101.092 155.742 89.3136 139.037 83.9414 130.928Z",
    fill: "#FCCFC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.759 97.1774C144.516 102.043 146.279 99.2047 147.192 97.1774C149.017 93.8325 149.32 86.2303 149.016 81.9731C148.712 77.7159 145.063 76.8037 144.151 83.4936C143.238 90.1834 146.279 82.5813 146.583 89.5753C146.887 96.5693 145.063 91.0957 144.759 97.1774Z",
    fill: "#FB9E82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62 97.485C74.8632 102.35 73.0996 99.5123 72.1873 97.485C70.3624 94.1401 70.0591 86.5379 70.3632 82.2807C70.6673 78.0235 74.3161 77.1113 75.2284 83.8012C76.1406 90.4911 73.0998 82.8889 72.7957 89.8829C72.4916 96.8769 74.3159 91.4033 74.62 97.485Z",
    fill: "#FB9E82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6375 50.6519C79.0154 55.274 77.6571 73.0529 77.5557 81.3646C75.1231 76.2559 71.6768 74.3706 70.2577 74.0665C67.825 66.7685 69.3454 44.8743 71.1699 42.1375C72.9945 39.4007 79.9884 19.027 111.613 21.1556C143.238 23.2842 148.408 44.5702 148.408 47.9151C148.408 50.5911 149.016 67.2753 149.016 75.2829C145.367 75.5261 143.441 79.4387 143.238 81.3646L137.157 57.3418C131.561 54.6658 99.1459 51.7669 83.6375 50.6519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.789 132.45C95.4359 132.45 86.5768 120.692 83.9414 114.813C86.3741 125.456 102.491 137.62 111.005 140.965C117.817 143.641 127.426 142.891 131.379 142.181L135.94 133.667V115.726C133.203 121.301 124.142 132.45 109.789 132.45Z",
    fill: "#FB9E82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2470_23284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    rx: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleAvatar);
export default __webpack_public_path__ + "static/media/MaleAvatar.f41d9ba7112d3cbc30bf363df2f5c2d9.svg";
export { ForwardRef as ReactComponent };